/* src/app/private/configrations/whatsapp-template/whatsapp-template.component.scss */
.status_chip {
  display: flex;
  gap: 7px;
  width: fit-content;
  padding: 5px 16px;
  border-radius: 6px;
  font-size: 13px;
  text-transform: capitalize;
}
/*# sourceMappingURL=whatsapp-template.component.css.map */
